import React, { useState } from "react";
import "../../Styles/Redirecting Styles/WebDevelopment.css";
import Footer from "../../Components/Footer";
import { faPhone, faPlay } from "@fortawesome/free-solid-svg-icons";
import "../../Styles/Service.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Header1 from "../../Components/seperate Components/Header1";
import "../../Styles/Redirecting Styles/NavbarStyles/Business.css";
import Shape2 from "../../assets/brand/choose-shape-2.png";
import service from "../../newimgs/domain consultancy.png";
import service2 from "../../newimgs/IT Engineering.png";
// import service22 from "../../assets/All Images/seervice2.jpg";
// import businessAutomation from "../../assets/All Images/business-automation.jpg";
// import businessService from "../../assets/All Images/business-service.jpg";
// import businesAutomation from "../../assets/icons/business-automation.png";
// import productive from "../../assets/icons/productive.png";
// import customer from "../../assets/icons/customer.png";
// import tracking from "../../assets/icons/tracking.png";
// import ModalVideo from "react-modal-video";
import "react-modal-video/scss/modal-video.scss";
import { Helmet } from "react-helmet";
import { BrandArea2 } from "../../Components/BrandArea2";
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Blog from "../../Components/Blog";
import { BrandArea3 } from "../../Components/BrandArea3";


// import sales from "../../assets/All Images/sales.jpg";
// import sales1 from "../../assets/All Images/sales1.jpg";
// import sales2 from "../../assets/All Images/sales2.jpg";
// import Blog from "../FooterPages/Blog";
const WebDevelopment = () => {
  const [isOpen, setOpen] = useState(false);


    const location = useLocation();

  useEffect(() => {
    if (location.hash === "#it-services") {
      const element = document.getElementById("it-services");
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    }
    if (location.hash === "#domain-services") {
      const element = document.getElementById("domain-services");
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    }
  }, [location]);
  return (
    <div>
      <Helmet>
        <title>
         Services
        </title>
        <meta
          name="description"
          content="Supercharge your business with our top-notch automation solutions. Streamline your processes and work smarter."
        />
        <meta
          name="keywords"
          content="Business automation specialist, business automation expert, business process automation, business automation solutions."
        />
      </Helmet>

      <Header1 />

      {/* Banner section */}
      <div
        className="bd-page-title-area bd-page-title-bg2 pt-120 pb-20"
        // style={{ height: "380px" }}
      >
        <div className="container buisnessHeader">
          <div className="row">
            <div className="col-12">
              <div
                className="bd-page-title text-center z-index"
                
              >
                <h2
                  className="breadcrumb-title buisnessH2 "
                  style={{ fontSize: "47px", color: "#01536E" }}
                >
                  Our Services
                </h2>
                {/* <div className="breadcrumb-menu">
                  <nav className="breadcrumb-trail breadcrumbs">
                    <p style={{ color: "black" }}>
                      Business automation blends technology with strategy to
                      streamline operations and enhance efficiency.
                    </p>
                  </nav>
                </div> */}
              </div>
            </div>
          </div>
        </div>
      </div>
       

       {/* New Section - Digital Transformation */}
<section className="bd-choose-area fix  pb-20 buisnessFirstText" style={{marginTop:"-20px"}}>
  <div className="container" style={{ maxWidth: "1270px" }}>
    <div className="bd-choose-shape">
      <div className="row justify-content-center">
        <div className="col-12">
          <div className="bd-choose-text z-index" style={{ textAlign: "center" }}>
            <div className="bd-section-title-wrapper mb-35">
              {/* Optionally you can add a title here if needed */}
            </div>
            <div>
              <p style={{ width: "95%", fontSize: "16px", margin: "0 auto",fontWeight:"600" ,color: "#5d5e5fff", wordSpacing: "2px" }}>
                Digital Transformation - Across the Value chain - <br/>Through leveraging Technology.
              </p><br/>
              <p style={{ width: "95%", fontSize: "16px", margin: "0 auto", color: "#5d5e5fff", wordSpacing: "2px" }}>
                We co-create business critical outcomes with our clients and partners,<br/>
                 ensuring razor-sharp focus on <span style={{fontWeight:"600"}}>Business Value, Time to Market,</span> <br/><span style={{fontWeight:"600"}}>Quality</span> and Cost Discipline.
              </p><br/>
              <p style={{ width: "95%", fontSize: "16px", margin: "0 auto", color: "#5d5e5fff", wordSpacing: "2px" }}>
                We operate as a <span style={{fontWeight:"600"}}>core team</span> comprising former executives from Global<br/>
                 tier 1 firms complemented by <span style={{fontWeight:"600"}}>Competency partners</span> who have proven <br/>
                 competencies in specific technology or industry domains.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>





      {/* First Section */}

      <section id="domain-services"  className="bd-choose-area fix pt-80 pb-80 buisnessSecond">
        <div className="container" style={{ maxWidth: "1270px" }}>
          <div className="bd-choose-shape">
            <div className="row">
              <div className="col-xl-6 col-lg-6 order-2 order-lg-1 pr-20">
                <div className="bd-choose-text z-index ">
                  <div className="bd-section-title-wrapper ">
                    
                    <h4 className="bd-section-title mb-15 first_section-title domainTxt ">
Domain Consultancy Services                    </h4>
                  </div>

             
                                      <p
                    className="mb-20 first_section_para1 servicePres"
                    style={{ fontSize: "16px" }}
                  >
Ambrella brings deep domain experience delivered via flexible consulting models to 
conceptualize, embed and leverage digital transformation in the fabric of your enterprise.
                  </p>
<ul className="mb-20 first_section_para1 " style={{ width: "95%", fontSize: "16px", paddingLeft: "20px" ,color: "#5d5e5fff" }}>
  <li>Customer Experience (CX) Transformation</li>
  <li>Process Automation & Digitalization</li>
  <li>Core Banking Transformation</li>
  <li>ERP & Supply Chain Transformation</li>
  <li>IT Infrastructure Modernization</li>
  <li>Data & Analytics</li>
  <li>AI/ML Strategy</li>
  <li>Workforce Transformation</li>
</ul>
                 
                </div>
              </div>
              <div className="col-xl-6 col-lg-6 order-1 order-lg-2">
                <div className="bd-choose-img text-end top-resp z-index d-flex justify-content-center align-items-center">
                  <div className=" align-items-center  custom-mar-15 d-flex justify-content-center align-items-center">
                    <div className="col-xl-12 col-lg-12 col-12 custom-pad-15 d-flex justify-content-center align-items-center" >
                      <div className="bd-choose-img-inner mb-15 bd-choose-img-inner-1 d-flex justify-content-center align-items-center">
                        <img
                          src={service}
                          className="resp-img  buisnessimg1"
                          alt="img not found"
                           style={{ width: "90%", height: "90%", objectFit: "cover" }}
                        />
                      </div>
                    </div>
                    {/* <div className="col-xl-6 col-lg-6 col-6 custom-pad-15">
                      <div className="bd-choose-img-inner mb-15">
                        <img
                          src={service1}
                          className="resp-img"
                          className="resp-img bordertop-img2"
                          alt="img not found"
                        />
                      </div>
                      <div className="bd-choose-img-inner mb-15">
                        <img
                          src={service2}
                          className="resp-img bordertop-img3"
                          alt="img not found"
                        />
                      </div>
                    </div> */}
                  </div>
                  {/* <img
                    className="bd-choose-shape bd-choose-shape-2"
                    src={Shape2}
                    alt="shape img not found"
                  /> */}
                  {/* <div className="bd-choose-video-popup">
                                    <a href="https://www.youtube.com/watch?v=jdkWIdJobSA" className="play_btn popup-video"><i className="fas fa-play"></i></a>
                  </div> */}
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* <ModalVideo
          autoplay
          isOpen={isOpen}
          channel="youtube"
          videoId="2LRxhuDssLQ"
          onClose={() => setOpen(false)}
        ></ModalVideo>
        <button
          className="btn btn responsive_digital first_pop_video_business"
          onClick={() => setOpen(true)}
        >
          <FontAwesomeIcon
            icon={faPlay}
            className="play_bt_vid play_transition"
          />
        </button> */}
      </section>



      
      <BrandArea2/>

            <section id="it-services" className="bd-choose-area fix pb-100 pt-100 buisnessForth">
              <div className="container" style={{ maxWidth: "1270px" }}>
                <div className="bd-choose-shape">
                  <div className="row">
                    <div className="col-xl-6 col-lg-6 order-2 order-lg-1 pr-20">
                      <div className="bd-choose-text z-index">
                        {/* <h2
                          className="bd-section-title mb-15"
                          style={{ fontSize: "38px" }}
                        >
                          IT Engineering Services
                        </h2> */}


                                       <div className="bd-section-title-wrapper ">
                    
                    <h4 className="bd-section-title mb-15 first_section-title domainTxt">
 IT Engineering Services                  </h4>
                  </div>
                        <div className="bd-section-title-wrapper"></div>
                        <p
                          className="mb-20 servicePres"
                          style={{ width: "95%", fontSize: "16px" }}
                        >
             Helping enterprises build, operate and maintain Data, Logic, Network and 
             Integration assets in Data Stores, Apps and APIs in Cloud/Hybrid environments.
      
                        </p>
<ul className="" style={{ fontSize: "16px", paddingLeft: "20px" , color: "#5d5e5fff" }}>
  <li>Ambrella offers end to end services in Application Engineering space to maximise your investment in technology</li>
  <li>Custom (Bespoke) Application Development</li>
  <li>Package Implementations/Systems Integration</li>
  <li>Operations support in subscription (as-a-service) models</li>
  <li>Testing/Quality Assurance</li>
  <li>Application & Data Integration</li>
  <li>IT Infrastructure & Cloud Management</li>
  <li>App Support/Maintenance</li>
  <li>Enterprise Solution Services</li>
  <li>Resource Hiring & Staff Augmentation</li>
</ul>
                      </div>
                    </div>
                        <div className="col-xl-6 col-lg-6 order-1 order-lg-2">
                <div className="bd-choose-img text-end top-resp z-index d-flex justify-content-center align-items-center">
                  <div className=" align-items-center  custom-mar-15 d-flex justify-content-center align-items-center">
                    <div className="col-xl-12 col-lg-12 col-12 custom-pad-15 d-flex justify-content-center align-items-center" style={{marginTop:"20px"}}>
                      <div className="bd-choose-img-inner mb-15 bd-choose-img-inner-1 d-flex justify-content-center align-items-center">
                        <img
                          src={service2}
                          className="resp-img  buisnessimg2"
                          alt="img not found"
                           style={{ width: "90%", height: "90%", objectFit: "cover" }}
                        />
                      </div>
                    </div>
                    {/* <div className="col-xl-6 col-lg-6 col-6 custom-pad-15">
                      <div className="bd-choose-img-inner mb-15">
                        <img
                          src={service1}
                          className="resp-img"
                          className="resp-img bordertop-img2"
                          alt="img not found"
                        />
                      </div>
                      <div className="bd-choose-img-inner mb-15">
                        <img
                          src={service2}
                          className="resp-img bordertop-img3"
                          alt="img not found"
                        />
                      </div>
                    </div> */}
                  </div>
                  {/* <img
                    className="bd-choose-shape bd-choose-shape-2"
                    src={Shape2}
                    alt="shape img not found"
                  /> */}
                  {/* <div className="bd-choose-video-popup">
                                    <a href="https://www.youtube.com/watch?v=jdkWIdJobSA" className="play_btn popup-video"><i className="fas fa-play"></i></a>
                  </div> */}
                </div>
              </div>
                  </div>
                </div>
              </div>
      
              {/* <div className="bd-choose-video-popup first_pop_video"> */}
              {/* <ModalVideo
                autoplay
                isOpen={isOpen}
                channel="youtube"
                videoId="L61p2uyiMSo"
                onClose={() => setOpen(false)}
              ></ModalVideo>
              <button
                style={{ display: "none" }}
                className="btn btn  first_pop_video responsive_digital"
                onClick={() => setOpen(true)}
              >
                <FontAwesomeIcon
                  icon={faPlay}
                  className="play_bt_vid play_transition"
                />
              </button> */}
      
              {/* </div> */}
            </section>

      {/* Second Section */}
      {/* <section className="bd-about-area-two ">
        <div className="container" style={{ maxWidth: "1270px" }}>
          <div className="row justify-content-center">
            <div className="col-xl-6 col-lg-8 second_section_Business1">
              <div className="bd-about-img-two">
                <img
                  src={businessAutomation}
                  className="pl-110"
                  alt="img not found"
                  style={{ width: "93%" }}
                />

              </div>
            </div>
            <div className="col-xl-6 col-lg-8 second_section_Business2">
              <div className="bd-about-text-two">
                <div className="bd-section-title-wrapper mb-25">
                  <h2 className="bd-section-title mb-15 second_sec_tittle">
                    {" "}
                    <span style={{ color: "#098FB4" }}>
                      Business Automation{" "}
                    </span>
                    Is the next game changer that leaders should embrace.
                  </h2>
                  <p>
                    Business automation services offer numerous benefits to
                    business leaders, enhancing efficiency and accuracy. For
                    instance, they help speed up task completion, ensure
                    consistency in operations, and reduce costs. Additionally,
                    automation improves communication and collaboration between
                    business owners and employees. With automation software,
                    businesses can streamline tasks and processes, making
                    workflows faster and more efficient. This not only saves
                    time and money but also helps keep operations
                    well-organized. Furthermore, automation software supports
                    businesses in staying compliant with regulations,
                    strengthening their compliance posture.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section> */}

      {/* Third Section */}
      {/* <section className="bd-service-area pt-80 ">
        <div className="container" style={{ maxWidth: "1270px" }}>
          <div className="row">
            <div className="col-12">
              <div className="bd-section-title-wrapper text-center mb-25">
                <h2
                  className="bd-section-title mb-10 third_sec_tittle"
                  style={{ textAlign: "left" }}
                >
                  Boosting Your Business Efficiency with{" "}
                  <span style={{ color: "#098FB4" }}>Business Automation</span>{" "}
                </h2>
              </div>
            </div>
          </div>
          <h4 className="bd-service-title mb-20">
            <a>Types of Automation</a>
          </h4>
          <div className="row">
            <div className="col-lg-4 col-md-6">
              <div
                className="bd-service mb-30"
                style={{ backgroundColor: "var(--clr-bg-gray)" }}
              >
                <h4 className="bd-service-title mb-20">
                  <a>Task Automation.</a>
                </h4>
                <p>
                  Task automation software can streamline payroll processes,
                  allowing your HR team to focus on team development and other
                  key tasks.
                </p>
              </div>
            </div>
            <div className="col-lg-4 col-md-6">
              <div
                className="bd-service mb-30"
                style={{ backgroundColor: "var(--clr-bg-gray)" }}
              >
                <h4 className="bd-service-title mb-20">
                  <a>Workflow Automation.</a>
                </h4>
                <p>
                  Workflow management can be applied in areas like work
                  scheduling, on-call staff rotations, deadline tracking, and
                  service request assignments.
                </p>
              </div>
            </div>
            <div className="col-lg-4 col-md-6">
              <div
                className="bd-service mb-30"
                style={{ backgroundColor: "var(--clr-bg-gray)" }}
              >
                <h4 className="bd-service-title mb-20">
                  <a>Process Automation.</a>
                </h4>
                <p>
                  Fully automating business processes helps organizations
                  deliver products or services efficiently to customers while
                  making work smoother for staff.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section> */}

      {/* Fourth Section */}
      {/* <section className="bd-brand-area-two pb-80 pt-70">
        <div className="container" style={{ maxWidth: "1270px" }}>
          <div className="row fourt_respon_business">
            <div className="col-xl-4 col-lg-6 col-md-6 first_part_respons">
              <div className="col-12">
                <div className="bd-section-title-wrapper mb-20">
                  <h2 className="bd-section-title mb-25 pl-0 fourth_sec_tittle">
                    Pitfalls When Implementing{" "}
                    <span style={{ color: "#098FB4" }}>
                      {" "}
                      Business Automation
                    </span>{" "}
                  </h2>
                </div>
              </div>
            </div>
            <div className="col-xl-8 col-lg-6 col-md-6 second_part_respons">
              <div className="bd-brand-active-two swiper-container">
                <div className="swiper-wrapper">
                  <p style={{ fontSize: "18px", lineHeight: "1.75" }}>
                    Businesses adopting automation often face challenges. These
                    include handling repetitive tasks, completing them
                    efficiently, managing workflows, and identifying potential
                    issues. Sometimes, businesses may be unsure about the right
                    requirements or best practices for automation. They may also
                    lack the necessary resources to implement it effectively.
                    Additionally, companies need to navigate how to maximise
                    technology, oversee automation projects, and support
                    employees transitioning from manual work. To tackle these
                    challenges, businesses can explore various strategies for a
                    smoother automation journey.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section> */}

      {/* Fiveth Section */}
      {/* <section className="bd-about-six-area ">
        <div className="container" style={{ maxWidth: "1270px" }}>
          <div className="row fifth_section_responsive">
            <div className="col-lg-6 Business_fifth_flex1">
              <div className="bd-about-six-text">
                <div className="bd-section-title-wrapper mb-25">
                  <h2 className="bd-section-title mb-25 sixth_sec_tittle">
                    {" "}
                    <span style={{ color: "#098FB4" }}>
                      Business Automation{" "}
                    </span>{" "}
                    Service Tailored to Fit Your Business{" "}
                  </h2>
                  <div className="bd-about-six-feature">
                    <p className="" style={{ width: "95%" }}>
                      Businesses can assess if automation services suit their
                      needs by evaluating their specific requirements and
                      comparing offerings from different providers. To ensure
                      effectiveness and efficiency, they can also check customer
                      reviews of various service providers.
                    </p>

                    <p style={{ width: "95%" }}>
                      The three main types of business automation services are
                      software, hardware, and online tools. Software-based
                      businesses can leverage platforms like Salesforce or
                      QuickBooks to handle sales and accounting data.
                      Hardware-based businesses can automate tasks in factories
                      or warehouses using specialized machines for shipping and
                      handling. Online tools-based businesses can streamline
                      operations with platforms like Google Docs or Microsoft
                      Excel to manage paperwork and data efficiently.
                    </p>

                    <p style={{ width: "95%" }}>
                      No matter which business automation service you choose,
                      it’s important to understand the features and benefits
                      before making a decision. Businesses should also consider
                      the costs involved with each type of automation. Look no
                      further than our team of experts! Our business automation
                      services are designed to help you streamline and manage
                      your business processes efficiently, ensuring smooth and
                      seamless operations. Let us help you take your business to
                      the next level!
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-6 col-md-8 Business_fifth_flex2">
              <div className="bd-about-six-img">
                <div className="bd-about-six-feature">
                  <div className="bd-slider-six-img">
                    <img
                      src={businessService}
                      className="rounded-10"
                      alt="img not found"
                      style={{ width: "100%" }}
                    />
                    <img
                      src="https://res.cloudinary.com/ztpl-images/image/upload/q_auto,f_auto,fl_lossy/v1659587681/website/business-audit/slider-shape-3_rtsny4.png"
                      className="bd-slider-six-img-shape1"
                      alt="img not found"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section> */}

      {/* Sixth Section */}
      {/* <section className="bd-choose-area fix">
        <div className="container" style={{ maxWidth: "1300px" }}>
          <div className="bd-choose-shape pt-80 pb-80 ">
            <div className="row Business_resp_section">
              <div className="col-xl-6 col-lg-6 order-2 order-lg-1 sixth_sec1_resp">
              
                <div className="bd-choose-img z-index">
                  <div className="bd-choose-info-wrapper">
                    <div className="container">
                      <div className="row mb-50">
                        <div className="col business-resp mr-50">
                          <div className="animate-hover">
                            <div className="bd-choose-info-icon mb-15">
                              <i>
                                <img src={productive} />
                              </i>
                            </div>
                            <div className="bd-choose-info-text">
                              <h2
                                className="bd-choose-info-title mb-15"
                                style={{ color: "#5e5858" }}
                              >
                                Greater Productivity
                              </h2>
                            </div>
                          </div>
                        </div>
                        <div className="col">
                          <div className="animate-hover">
                            <div className="bd-choose-info-icon mb-15">
                              <i>
                                <img src={customer} />
                              </i>
                            </div>
                            <div className="bd-choose-info-text">
                              <h2
                                className="bd-choose-info-title mb-15"
                                style={{ color: "#5e5858" }}
                              >
                                Better Customer Service
                              </h2>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="container">
                      <div className="row ">
                        <div className="col mr-30">
                          <div className="animate-hover">
                            <div className="bd-choose-info-icon mb-15">
                              <i>
                                <img
                                  src={tracking}
                                  style={{ width: "62px" }}
                                />
                              </i>
                            </div>
                            <div className="bd-choose-info-text">
                              <h2
                                className="bd-choose-info-title mb-15"
                                style={{ color: "#5e5858" }}
                              >
                                Full Audibility and Tracking
                              </h2>
                            </div>
                          </div>
                        </div>
                        <div className="col">
                          <div className="animate-hover">
                            <div className="bd-choose-info-icon mb-15">
                              <i>
                                <img src={businesAutomation} />
                              </i>
                            </div>
                            <div className="bd-choose-info-text">
                              <h2
                                className="bd-choose-info-title mb-15"
                                style={{ color: "#5e5858" }}
                              >
                                Increased Efficiency & Improved Accuracy
                              </h2>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
             
              </div>
              <div className="col-xl-6 col-lg-6 order-1 order-lg-2 mt-0 sixth_sec2_resp">
                <div className="bd-choose-text z-index">
                  <h2 className="bd-section-title business-last-tittle">
                    How We Can Assist in System Development
                  </h2>
                  <div className="bd-section-title-wrapper">
                    <p style={{ fontSize: "18px", lineHeight: "1.75" }}>
                      Our mission is to help businesses operate smarter and more
                      efficiently. We offer a wide range of business automation
                      solutions to help you maximise your technology. With
                      top-quality tools and services, we ensure smoother and
                      more effective operations. Our automation services are
                      designed to be convenient, cost-effective, and help
                      businesses work smarter.
                    </p>
                  </div>
                  <div></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section> */}

      {/* CTA */}

      {/* <section
        className="bd-video-area pt-135 pb-130"
        style={{ backgroundColor: "#01536E" }}
      >
        <div className="container" style={{ maxWidth: "1270px" }}>
          <div className="row responsive-banner">
            <div className="col-lg-12 first_section">
              <div className="bd-video-text">
                <h2 className="bd-video-title first-para-resp">
                  Need a Business Automation Specialist?
                </h2>
                <p className="contact_section second-para-resp">
                  You’re in the right place, at the perfect time.{" "}
                </p>
                <p className="contact_subtext">
                Exceptional automation made easy let’s get started now!
                </p>
              </div>
            </div>
            <div className="col-lg-12 second_section">
              <div className="contact-stuff pt-30">
                <div className="contact_icon icon_respon pt-15 pl-50">
                  <FontAwesomeIcon
                    icon={faPhone}
                    style={{ fontSize: "30px" }}
                  />
                </div>
                <div className="contact_txt ">
                  <p className="contact-sub-text">CALL US NOW</p>
                  <a
                    href="tel:+6587852030"
                    style={{ fontSize: "17px" }}
                    className="mbb-5 pb-20"
                  >
                    +65 87852030
                  </a>
                </div>
              </div>
              <Link to={"/zithas/contact-us"} onClick={toggleContact}>
                    <button className="touch-btn1 mt-20">Get Started</button>
                    </Link>
            </div>
          </div>
        </div>
      </section> */}
      {/* <BrandArea2/> */}
      <BrandArea3/>
      <div className="mt-5" style={{marginBottom:"-30px"}}>
         <div className="Service-contact-class">
           <Blog/>
         </div>
      </div>
      <Footer />
      {/* </div> */}
    </div>
  );
};

export default WebDevelopment;
